/* Enord Core classic v1.0 — Buy box classic: gallery (thumbs + arrows) + variant switching (price, compare, pill, title, gallery, URL). */
(function(){
  document.querySelectorAll('[data-ebc]').forEach(function(root){
    var main=root.querySelector('[data-ebc-main]'),th=root.querySelector('[data-ebc-th]'),pv=root.querySelector('[data-ebc-prev]'),nx=root.querySelector('[data-ebc-next]');
    var ts=th?[].slice.call(th.querySelectorAll('[data-ebc-t]')):[],n=ts.length,tm;
    function cur(){return Math.max(0,Math.min(n-1,Math.round(main.scrollLeft/(main.clientWidth||1))))}
    function sync(){var i=cur();ts.forEach(function(t,j){t.classList.toggle('is-cur',j===i)});if(pv)pv.style.visibility=i<=0?'hidden':'visible';if(nx)nx.style.visibility=i>=n-1?'hidden':'visible';var t=ts[i],l=t.offsetLeft,r=l+t.offsetWidth;if(l<th.scrollLeft||r>th.scrollLeft+th.clientWidth)th.scrollTo({left:l-4,behavior:'smooth'})}
    if(main&&th){
      main.addEventListener('scroll',function(){clearTimeout(tm);tm=setTimeout(sync,60)},{passive:true});
      ts.forEach(function(t,i){t.addEventListener('click',function(){main.scrollTo({left:i*main.clientWidth,behavior:'smooth'})})});
      if(pv)pv.addEventListener('click',function(){main.scrollBy({left:-main.clientWidth,behavior:'smooth'})});
      if(nx)nx.addEventListener('click',function(){main.scrollBy({left:main.clientWidth,behavior:'smooth'})});
      sync();
    }
    /* variants */
    var sws=[].slice.call(root.querySelectorAll('[data-ebc-var]')),de=root.querySelector('[data-ebc-vdata]');
    if(!sws.length||!de)return;
    var V={};try{JSON.parse(de.textContent).forEach(function(v){V[v.id]=v})}catch(e){return}
    var idIn=root.querySelector('.product-variant-id'),pr=root.querySelector('[data-ebc-price]'),cm=root.querySelector('[data-ebc-compare]'),cw=cm&&cm.parentNode,pw=root.querySelector('[data-ebc-pillwrap]'),pl=root.querySelector('[data-ebc-pill]'),vt=root.querySelector('[data-ebc-vtitle]'),atc=root.querySelector('[data-ebc-atc]'),at=root.querySelector('[data-ebc-atc-t]');
    function pick(id){
      var v=V[id];if(!v)return;
      sws.forEach(function(s){var on=s.getAttribute('data-ebc-var')==id;s.classList.toggle('is-cur',on);s.setAttribute('aria-checked',on?'true':'false')});
      if(idIn){idIn.value=id;idIn.dispatchEvent(new Event('change',{bubbles:true}))}
      if(pr)pr.textContent=v.price;
      if(cm&&cw){cm.textContent=v.compare;cw.hidden=!v.compare}
      if(pw&&pl){pl.textContent=v.pill;pw.hidden=!v.pill}
      if(vt)vt.textContent=v.title;
      if(atc){if(at)at.textContent=v.available?atc.getAttribute('data-label'):atc.getAttribute('data-soldout');if(v.available)atc.removeAttribute('disabled');else atc.setAttribute('disabled','')}
      if(main&&v.media>=0)main.scrollTo({left:v.media*main.clientWidth,behavior:'auto'});
      try{var u=new URL(location.href);u.searchParams.set('variant',id);history.replaceState(null,'',u.toString())}catch(e){}
    }
    sws.forEach(function(s){s.addEventListener('click',function(){pick(s.getAttribute('data-ebc-var'))})});
  });
})();
/* v1.2: exclusive accordions – fallback for browsers without <details name> support */
document.addEventListener('toggle',function(e){var d=e.target;if(!d.matches||!d.matches('[data-ebc-ac]')||!d.open)return;document.querySelectorAll('[data-ebc-ac][name="'+d.getAttribute('name')+'"]').forEach(function(o){if(o!==d&&o.open)o.open=false})},true);

/* v1.4: mobile icon strip auto-advance (one icon per step, loops; pauses while touched / off-screen / tab hidden) */
(function(){function go(el){if(el.__a)return;el.__a=1;var ms=parseInt(el.getAttribute('data-ebc-auto'),10)||0;if(ms<500)return;var hold=0,t=0,vis=true;
el.addEventListener('touchstart',function(){hold=1;clearTimeout(t)},{passive:true});var rel=function(){clearTimeout(t);t=setTimeout(function(){hold=0},ms)};el.addEventListener('touchend',rel,{passive:true});el.addEventListener('touchcancel',rel,{passive:true});
if('IntersectionObserver' in window)new IntersectionObserver(function(es){vis=es[0].isIntersecting}).observe(el);
setInterval(function(){if(hold||!vis||document.hidden||!el.offsetParent)return;var s=el.children[1]?el.children[1].offsetLeft-el.children[0].offsetLeft:el.clientWidth;var max=el.scrollWidth-el.clientWidth;if(max<=2)return;var n=el.scrollLeft+s;el.scrollTo({left:n>max+2?0:Math.min(n,max),behavior:'smooth'});if(el.scrollLeft>=max-2)setTimeout(function(){},0)},ms)}
function all(){document.querySelectorAll('[data-ebc-auto]').forEach(go)}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all()})();

/* v1.5: keep --header-height equal to the real header height (theme can measure before fonts/logo load → header only half hides on scroll) */
(function(){function fix(){var h=document.querySelector('.section-header,sticky-header,.header-wrapper');if(!h)return;var el=h.closest('.section-header')||h;var v=el.offsetHeight;if(v>0)document.documentElement.style.setProperty('--header-height',v+'px')}
window.addEventListener('load',fix);window.addEventListener('resize',fix);if(document.fonts&&document.fonts.ready)document.fonts.ready.then(fix);setTimeout(fix,1500)})();

/* v1.9 Enord gift-ad (2026-10-21)
   Ad link: /products/<lumi|hummi>?gift=<CODE>&utm_...
   After "Add to cart" of the device: adds the gift variant, applies <CODE> (BXGY -> gift 0 EUR),
   sets cart attribute gift_ad=<CODE>, re-renders the cart drawer. No ?gift= in the URL this visit = does nothing.
   Triggers: buy-box submit (fast, one request) + PerformanceObserver on any /cart/add (fallback, e.g. STKY).
   Check in console: window.enGift -> the active code. */
(function(){
  var MAP={
    lt:{ // odoscentras.lt
      BRANDI:{d:'lumi', v:53606496698705}, GLOW:{d:'lumi', v:49899467211089}, SOS:{d:'lumi', v:51730263048529},
      SOS1:{d:'hummi',v:51730286936401}, ILGI:{d:'hummi',v:49348687692113}, FRESH:{d:'hummi',v:51730290770257}
    },
    lv:{ // adascentrs.lv
      BRIEDUMS:{d:'lumi', v:58858753196376}, GLOW:{d:'lumi', v:53532714467672}, SOS:{d:'lumi', v:58858660462936},
      SOS1:{d:'hummi',v:58858709418328}, GARI:{d:'hummi',v:50119783809368}, FRESH:{d:'hummi',v:58880019890520}
    }
  };
  var h=location.hostname, store=/odoscentras/.test(h)?'lt':/adascentrs/.test(h)?'lv':null;
  var m=location.pathname.match(/\/products\/([^\/?#]+)/);
  if(!store||!m)return;
  var handle=m[1], K='en_gift', code=null;
  try{
    var p=new URLSearchParams(location.search).get('gift');
    if(p)sessionStorage.setItem(K,p.toUpperCase());
    code=sessionStorage.getItem(K);
  }catch(e){}
  var g=code&&MAP[store][code];
  if(!g||g.d!==handle)return;
  window.enGift=code;

  var busy=false, J={'Content-Type':'application/json','Accept':'application/json'};
  function post(u,b){return fetch(u,{method:'POST',headers:J,body:JSON.stringify(b)}).then(function(r){return r.json()});}
  // One request: updates sets the gift line to qty 1 (adds it if missing), sets the attribute and the code, returns the drawer HTML.
  function apply(){
    var drawer=document.querySelector('cart-drawer'), b={updates:{},attributes:{gift_ad:code},discount:code};
    b.updates[g.v]=1;
    if(drawer&&drawer.getSectionsToRender){b.sections=drawer.getSectionsToRender().map(function(s){return s.id});b.sections_url=location.pathname;}
    return post('/cart/update.js',b).then(function(res){
      if(drawer&&res.sections)drawer.renderContents(res);
      var ok=(res.discount_codes||[]).some(function(d){return d.code.toUpperCase()===code&&d.applicable});
      if(!ok)return fetch('/discount/'+encodeURIComponent(code)+'?redirect=/cart.js'); // fallback: discount cookie
    });
  }
  function addGift(check){
    if(busy)return;busy=true;
    (check?fetch('/cart.js').then(function(r){return r.json()}).then(function(cart){
      var hasDevice=cart.items.some(function(i){return i.handle===handle});
      var hasGift=cart.items.some(function(i){return i.variant_id===g.v});
      return hasDevice&&!(hasGift&&cart.attributes&&cart.attributes.gift_ad===code);
    }):Promise.resolve(true))
    .then(function(go){if(go)return apply()})
    .catch(function(e){console.warn('en-gift',e)}).finally(function(){busy=false});
  }
  // Fast path: our buy box form. Runs the moment the theme finishes its add-to-cart (button loses 'loading').
  document.addEventListener('submit',function(e){
    var f=e.target;if(!f||!f.closest||!f.closest('product-form'))return;
    var btn=f.querySelector('[type=submit]');if(!btn)return;
    var seen=false,mo=new MutationObserver(function(){
      var l=btn.classList.contains('loading');if(l){seen=true;return}
      if(!seen)return;mo.disconnect();
      var err=f.closest('product-form').querySelector('.product-form__error-message-wrapper');
      if(err&&!err.hidden)return; // device was not added
      addGift(false);
    });
    mo.observe(btn,{attributes:true,attributeFilter:['class']});
  },true);
  // Fallback (STKY sticky bar or any other add-to-cart): checks the cart first.
  if('PerformanceObserver' in window){
    try{new PerformanceObserver(function(l){if(l.getEntries().some(function(e){return /\/cart\/add/.test(e.name)}))setTimeout(function(){addGift(true)},400)}).observe({type:'resource'})}catch(e){}
  }
})();
